import React, { Component } from 'react';

export default class MainSlider extends Component {
  render() {
    return <section class="home-3 section" id="home" style={{

    }}>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="home-content text-start">
                    <div class="title home-heading">
                        <h1 class="fw-bold"> Defenders of the Cøsmos here. </h1>
                        <p className='text-white'>Nots are NFTs that honor the Cosmos IBC chains with unique qualities and chain specific appeal.  Nots all have astronaut like features as we are all Cosmos-nots, and blends it with each chains personal qualities.</p>
                        {/* <button class="btn btn-dark rounded">Get Started <i
                                class="mdi mdi-arrow-top-right align-middle"></i></button> */}
                    </div>
                    <div class="mt-5 border-bottom"></div>
                    <div class="count-detail mt-5">
                        <div class="row">
                            <div class="col-lg-4 col-6">
                                <div class="counter-box">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <h2 class="counter_value fw-bold" data-bs-target="40">5</h2><span
                                            class="h2 fw-bold">%</span>
                                    </div>
                                    <p class="counter-caption">Celestial</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-6">
                                <div class="counter-box">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <h2 class="counter_value fw-bold" data-bs-target="130">10</h2><span
                                            class="h2 fw-bold">%</span>
                                    </div>
                                    <p class="counter-caption">Cosmic</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-6">
                                <div class="counter-box">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <h2 class="counter_value fw-bold" data-bs-target="20">15</h2><span
                                            class="h2 fw-bold">%</span>
                                    </div>
                                    <p class="counter-caption">Meteoric</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-6">
                                <div class="counter-box">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <h2 class="counter_value fw-bold" data-bs-target="20">30</h2><span
                                            class="h2 fw-bold">%</span>
                                    </div>
                                    <p class="counter-caption">stellar</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-6">
                                <div class="counter-box">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <h2 class="counter_value fw-bold" data-bs-target="20">40</h2><span
                                            class="h2 fw-bold">%</span>
                                    </div>
                                    <p class="counter-caption">Orbital</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="">
                    
                    <img src="images/cards.png" alt="img" class="img-fluid"/>
                    
                    
                    {/* <div class="card-body px-5 py-4">
                        <h2 class="mb-0 fw-bold">DISCOVER</h2>

                        <div class="deatil my-2">
                            <p class="fw-bold mb-0 f-14">Sell Price</p>

                            <div class="d-flex">
                                <span class="h4 fw-bold">2.06 ETH</span>
                                <p class="f-14 fw-bold mt-1 ms-2">($15,237,08)</p>
                            </div>
                        </div>

                        <div class="d-flex">
                            <button class="btn btn-dark rounded">Bid</button>
                            <button class="btn btn-outline-dark ms-2 rounded">View Artwork</button>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    </div>
</section>;
  }
}
